export function degToRad(deg) {
  return (deg * Math.PI) / 180;
}
